<ng-container *ngIf="permConfig.isEditAllowed">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Update</h4>
        <button type="button" aria-label="Close" class="btn-close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="taxesEditForm" (ngSubmit)="updateTaxes()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="rateType" class="form-label">Rate Type <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="rateType" placeholder="Select" [items]="rateTypeList" formControlName="ddlRateType"
                                            bindLabel="ratetype" [bindValue]="'id'"
                                            [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm?.get('ddlRateType')?.touched) && taxesEditForm?.get('ddlRateType').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isModelSubmitted || taxesEditForm?.get('ddlRateType')?.touched) && taxesEditForm?.get('ddlRateType').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="taxesEditForm?.get('ddlRateType').errors.required">Rate
                                                Type is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="showCategory">
                                    <div class="mb-2">
                                        <label for="rateCategoryType" class="form-label">Category
                                        </label>
                                        <ng-select id="rateCategoryType" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" [items]="rateCategoriesList" formControlName="ddlRateCategory" bindLabel="ratecategory"[bindValue]="'id'"
                                            [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm?.get('ddlRateCategory')?.touched) && taxesEditForm?.get('ddlRateCategory').errors}" >
                                        </ng-select>
                                        <div *ngIf="(isModelSubmitted || taxesEditForm?.get('ddlRateCategory')?.touched) && taxesEditForm?.get('ddlRateCategory').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="taxesEditForm?.get('ddlRateCategory').errors.required">Category
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="fromDate" class="form-label">From Date <span class="mandatory">*</span></label>
                                        <input id="fromDate" class="form-control form-control-sm"
                                            type="date" formControlName="txtFromDate"
                                            [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm?.get('txtFromDate')?.touched) && taxesEditForm?.get('txtFromDate').errors}" >
                                        <div *ngIf="(isModelSubmitted || taxesEditForm?.get('txtFromDate')?.touched) && taxesEditForm?.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="taxesEditForm?.get('txtFromDate').errors.required">Date
                                                is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="mb-2">
                                        <label for="toDate" class="form-label">To Date <span class="mandatory">*</span></label>
                                        <input id="toDate" class="form-control form-control-sm" type="date" formControlName="txtToDate"
                                            [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm?.get('txtToDate')?.touched) && taxesEditForm?.get('txtToDate').errors}"
                                            min="{{ currentDate.dateString | date: 'yyyy-MM-dd' }}" >
                                        <div
                                            *ngIf="(isModelSubmitted || taxesEditForm?.get('txtToDate')?.touched) && taxesEditForm?.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesEditForm?.get('txtToDate').errors.required">Date is Required</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <ng-container *ngIf="showBands">
                                    <div class="col-md-4">
                                        <div class="mb-2">
                                            <label for="rateBands" class="form-label">Rate Bands <span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="rateBands" [items]="rateBandList"
                                                bindLabel="rateband" placeholder="Select" [bindValue]="'id'" formControlName="ddlRateBand"
                                                [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm?.get('ddlRateBand')?.touched) && taxesEditForm?.get('ddlRateBand').errors}" >
                                            </ng-select>
                                            <div *ngIf="(isModelSubmitted || taxesEditForm?.get('ddlRateBand')?.touched) && taxesEditForm?.get('ddlRateBand').errors"
                                                class="invalid-feedback">
                                                <span
                                                    *ngIf="taxesEditForm?.get('ddlRateBand').errors.required">Rate
                                                    Band is Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showCustomer">
                                    <div class="col-md-4">
                                        <div class="mb-2">
                                            <label for="customerRate" class="form-label">Customer<span class="mandatory">*</span></label>
                                            <ng-select id="customerRate" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" [items]="customerList" bindLabel="name" placeholder="Select" [bindValue]="'id'" formControlName="ddlCustomer"
                                                [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm?.get('ddlCustomer')?.touched) && taxesEditForm?.get('ddlCustomer').errors}" >
                                                <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                                    <span>{{ item.name }}</span>
                                                </ng-template>
                                            </ng-select>
                                            <div *ngIf="(isModelSubmitted || taxesEditForm?.get('ddlCustomer')?.touched) && taxesEditForm?.get('ddlCustomer').errors"
                                                class="invalid-feedback">
                                                <span
                                                    *ngIf="taxesEditForm?.get('ddlCustomer').errors.required">Customer is Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showVendor">
                                    <div class="col-md-4">
                                        <div class="mb-2">
                                            <label for="headerVendor" class="form-label">Vendor<span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="headerVendor" [items]="vendorList" bindLabel="name"
                                                placeholder="Select" [bindValue]="'id'" 
                                                
                                                [openOnEnter]="false" formControlName="ddlVendor"
                                                [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm.get('ddlVendor').touched) && taxesEditForm.get('ddlVendor').errors}">
                                            </ng-select>
                                            <div *ngIf="(isModelSubmitted || taxesEditForm.get('ddlVendor').touched) && taxesEditForm.get('ddlVendor').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="taxesEditForm.get('ddlVendor').errors.required">Vendor is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="mb-2">
                                        <label for="company" class="form-label">Company </label>
                                        <ng-select formControlName="ddlCompany"
                                            id="company" [items]="companyList" bindLabel="name" [bindValue]="'id'"
                                            placeholder="select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false" >
                                            <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                                <span>{{ item.name }}</span>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="product" class="form-label">Product</label>
                                        <ng-select id="product" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"[items]="productList" bindLabel="name" [bindValue]="'code'" placeholder="Select" formControlName="ddlProduct" >
                                            <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                                <span>{{ item.name }}</span>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="igst" class="form-label">IGST %<span class="mandatory">*</span></label>
                                        <input type="number" class="form-control form-control-sm" id="igst" formControlName="txtIGST" appLimitDigits [length] = "6"
                                        [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm.get('txtIGST').touched) && taxesEditForm.get('txtIGST').errors}" >
                                        <div *ngIf="(isModelSubmitted || taxesEditForm.get('txtIGST').touched) && taxesEditForm.get('txtIGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesEditForm.get('txtIGST').errors.required">IGST is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="cgst" class="form-label">CGST %<span class="mandatory">*</span></label>
                                        <input type="number" class="form-control form-control-sm" id="cgst" formControlName="txtCGST" appLimitDigits [length] = "6"
                                        [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm.get('txtCGST').touched) && taxesEditForm.get('txtCGST').errors}" >
                                        <div *ngIf="(isModelSubmitted || taxesEditForm.get('txtCGST').touched) && taxesEditForm.get('txtCGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesEditForm.get('txtCGST').errors.required">CGST is Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="sgst" class="form-label">SGST %<span class="mandatory">*</span></label>
                                        <input type="number" class="form-control form-control-sm" id="sgst" formControlName="txtSGST" appLimitDigits [length] = "6"
                                        [ngClass]="{'is-invalid': (isModelSubmitted || taxesEditForm.get('txtSGST').touched) && taxesEditForm.get('txtSGST').errors}" >
                                        <div *ngIf="(isModelSubmitted || taxesEditForm.get('txtSGST').touched) && taxesEditForm.get('txtSGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesEditForm.get('txtSGST').errors.required">SGST is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12">
                <div class="button-items mb-2">
                    <button type="submit" class="btn btn-primary w-sm" (click)="updateTaxes()" >Update</button>
                    <button type="button" class="btn btn-secondary w-sm"
                    (click)="activeModal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isEditAllowed">
    <app-forbidden></app-forbidden>
</ng-container>